export default __webpack_public_path__ + "static/desktop_KV12-7c293f6469d9906c189ffb2fe714d8f6.mp4";